import store from '@/store';

export default path => () => {
  store.commit('loading/add', path);
  return import(`@/views/${path}.vue`).then(
    (data) => {
      store.commit('loading/remove', path);
      return data;
    },
    (reject) => {
      store.commit('loading/remove', path);
      return reject;
    },
  );
};
